module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.previewSection) ? _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('div', {
    staticClass: "featured_block"
  }, [(_vm.previewSection.accolade_image) ? _c('div', {
    staticClass: "featured_block__image"
  }, [_c('img', {
    staticClass: "img-responsive-height ",
    attrs: {
      "src": _vm.previewSection.accolade_image.url,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.previewSection.title)
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.section.page_content), function(accolade) {
    return _c('sk-flex', {
      key: accolade.nid,
      attrs: {
        "grow": ""
      }
    }, [_c('div', {
      staticClass: "featured_block"
    }, [(accolade.accolade_image) ? _c('div', {
      staticClass: "featured_block__image"
    }, [_c('img', {
      staticClass: "img-responsive-height ",
      attrs: {
        "src": accolade.accolade_image.url,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(accolade.title)
      }
    })])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-096b7c3c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/accolades_block/accolades_block.vue
// module id = 672
// module chunks = 0